<template>
  <div id="menu" class="overflowAuto" hidden>
    <div class="container">
      <div class="row no-gutters">
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item menu-dialer-top">
          <a href="/dialer" @click="abrirTelaOperador">
            <div
              class="menu-background menu-dialer"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Tela do Operador"
              data-content="Acesse a central operacional do sistema, efetue discagens automaticamente conforme programado por Campanhas, Agendamentos ou atue na área Receptiva."
            >
              <i class="fas fa-phone-square icon"></i>
              <br />Tela do Operador
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item menu-realtime-top">
          <a href="/realtime">
            <div
              class="menu-background menu-realtime"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Realtime"
              data-content="Monitore e gerencie em tempo real sua equipe de telemarketing."
            >
              <i class="fas fa-clock icon"></i>
              <br />Realtime WhatsApp
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item menu-history-top">
          <a href="/history">
            <div
              class="menu-background menu-history"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Histórico"
              data-content="Visualize histórico de atendimentos via chat."
            >
              <i class="fas fa-history icon"></i>
              <br />Histórico de Conversas
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item menu-customer_base-top">
          <a href="/customer_base">
            <div
              class="menu-background menu-customer_base"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Carteira de Clientes"
              data-content="Confira sua carteira de clientes filtrando por operador e cliente."
            >
              <i class="fas fa-list-ol icon"></i>
              <br />Contatos
            </div>
          </a>
        </div>
        <!-- <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item menu-records-top">
          <a href="/records">
            <div
              class="menu-background menu-records"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Gravações"
              data-content="Ouça todas as chamadas de entrada e saída, contando com filtros para uma busca específica."
            >
              <i class="fas fa-voicemail icon"></i>
              <br />Gravações
            </div>
          </a>
        </div> -->
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item menu-templates-top">
          <a href="/templates">
            <div
              class="menu-background menu-templates"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Templates"
              data-content="Gerencie seus templates de abertura de conversas"
            >
              <i class="fas fa-comments icon"></i>
              <br />Templates
            </div>
          </a>
        </div>

        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item menu-reports-top">
          <a href="/reports">
            <div
              class="menu-background menu-reports"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Relatórios"
              data-content="Otimize suas decisões com o auxílio de relatórios de faturamento, operadores e chamadas."
            >
              <i class="fas fa-signal icon"></i>
              <br />Relatórios
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item menu-marketing-top">
          <a href="/marketing">
            <div
              class="menu-background menu-marketing"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Lista de Transmissão"
              data-content="Crie campanhas de mensagens massivas por meio de SMS, EMAIL e MENSAGEM FONADA."
            >
              <i class="fas fa-comment icon"></i>
              <br />Lista de Transmissão
            </div>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-lg-4 col-md-4 col-xl-3 menu-item menu-user-top">
          <a href="/user">
            <div
              class="menu-background menu-user"
              data-popover="true"
              data-placement="bottom"
              data-trigger="hover"
              title="Usuário"
              data-content="Crie e gerencie os usuários do sistema."
            >
              <i class="fas fa-users icon"></i>
              <br />Usuário
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    //SO SEGUE LOGADO A ABA QUE ACABOU DE AUTENTICAR (VER window.loginRecente NO layout.blade.php)
    const loginRecente = window.loginRecente === true;
    const abaAutenticada = sessionStorage.getItem('aba_autenticada') === 'true';

    if (loginRecente) {
      sessionStorage.setItem('aba_autenticada', 'true');
    } else if (!abaAutenticada) {
      window.location.replace('/exit');
      return;
    }

    setTimeout(() => {
      this.cancelarLogoutPage();
    }, 700);

    this.permissions();
    var url = window.location.href;
    url = url.split('/');
    if((url[3] == '') || (url[4] == '')){
      $("#menu").attr("hidden", false);
      $("#menuButton").attr("hidden", true);
    }

  },
  methods:{
           //DESFAZ O LOGOUT_PAGE GRAVADO AO SAIR DA TELA DO OPERADOR PARA A HOME
           cancelarLogoutPage: function () {
                if (sessionStorage.getItem('operador_logado') !== 'true') {
                    return;
                }

                axios.post('/dialer/cancel-page-logout', {
                    extension_line: user.getExtension()
                }).catch(() => {});
            },

           //MARCA QUE A SAIDA DA HOME E UMA NAVEGACAO INTERNA, NAO O FECHAMENTO DA ABA
           abrirTelaOperador: function () {
                sessionStorage.setItem('abrindo_tela_operador', 'true');
            },

           permissions: function () {
                axios.get('/permission')
                    .then(response => {
                      $(response.data.allowed).each(function(index, item){
                          $(`.menu-${item}`).css('background', `linear-gradient(rgba(4, 85, 142, 0.3), rgba(4, 85, 142, 0.5)), url('/imgs/menu/${item}-bkg.png')`);
                        })
              $(response.data.denied).each(function(index, item){
                //document.querySelector(`.menu-${item}-top`).style.display = 'none';
                //$(`.menu-${item}`).css('display', 'none');
                  $(`.menu-${item}`).css('background', `linear-gradient(rgba(13, 14, 15, 0.9), rgba(13, 14, 15, 0.9)), url('/imgs/menu/${item}-bkg.png')`);
                  $(`.menu-${item} .icon`).removeClass().addClass('fas fa-lock icon');
              })

                    }).catch(error => {
                    console.error(error)
                })
            }
  }
};
</script>
